
import { defineComponent, ref } from 'vue'
import iconsData from "./iconSVG.js";

export default defineComponent({
  name: 'alpIcon',
  props: {
    // icons 文件
    icon: String,
    // svg/img  默认img
    type: String,
    // icon大小 px
    size: Number,
  },
  computed: {
    calcIconStyle: function(){
      if(this.size){
        return {
          width: parseFloat(''+this.size)+'px',
          height: parseFloat(''+this.size)+'px',
        }
      }
    }
  },
  data: function(){
    return {
      iconPath: '',
      svgImg: "",
    }
  },
  setup: function(){
    const icons = <any>{};
    iconsData.icons.forEach(one => {
      icons[one.name] = one.svg;
    });
    return {
      icons,
    }
  },
  methods: {
    parseIcon: function(icon){
      var svg = this.icons[icon];
      this.iconPath = svg;
      this.svgImg = "data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(svg))); 
    },
  },
  watch: {
    "icon": function(val){
      this.parseIcon(val);
    },
  },
  created: function(){
    this.parseIcon(this.icon);
  }
})
